define(function(require) {
    // RESEAU_COLLEGIAL themeset definition config
    var DomUtil = require("cartovista").DomUtil;
    return  {
        ID : "RESIDENCE_ALL",
        TYPE : "ThemeSetGroup",
        TITLE : "Par lieux de résidence de l'élève",
        THEMESETS_ELEMENTS : [
            {
                ID : "RESIDENCE_ARROND",
                TYPE : "ThemeSetGroup",
                TITLE : "Arrondissements",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Res_ARRND_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E17_ARRND",
                        SELECTED_SEARCH_LAYER : "GEO09E17_ARRND",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E17_ARRND", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E17_ARRND",
                                DATATABLE_ID : "t_GEO09E17_ARRND_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PROV_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ARROND_TX_SANS_D_PROV_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ]
                    },
                    {
                        ID : "Res_ARRND_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public",
                        SELECTED_DATAVIEW_LAYER : "GEO09E17_ARRND",
                        SELECTED_SEARCH_LAYER : "GEO09E17_ARRND",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E17_ARRND", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E17_ARRND",
                                DATATABLE_ID : "t_GEO09E17_ARRND_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PUBLIC_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ARROND_TX_SANS_D_PUBLIC_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 5,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 5%"
                                        }, {
                                            MIN_VALUE : 5,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "5% à 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 15,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "10% à 15%"
                                        }, {
                                            MIN_VALUE : 15,
                                            MAX_VALUE : 20,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "15% à 20%"
                                        }, {
                                            MIN_VALUE : 20,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "20% et plus"
                                        }]
                                },
                            }
                        ]
                    },
                    {
                        ID : "Res_ARRND_3",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé",
                        SELECTED_DATAVIEW_LAYER : "GEO09E17_ARRND",
                        SELECTED_SEARCH_LAYER : "GEO09E17_ARRND",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E17_ARRND", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                            ]
                        },
                        THEMES:[
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E17_ARRND",
                                DATATABLE_ID : "t_GEO09E17_ARRND_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PRIVE_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "ARROND_TX_SANS_D_PRIVE_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ]
                    }
                ]
            }, {
                ID : "RESIDENCE_MUNCP",
                TYPE : "ThemeSetGroup",
                TITLE : "Municipalités",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Res_MUNCP_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E04_MUNCP_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E04_MUNCP_GEN",
                                DATATABLE_ID : "t_GEO09E04_MUNCP_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PROV_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MUNCP_TX_SANS_D_PROV_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_MUNCP_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public",
                        SELECTED_DATAVIEW_LAYER : "GEO09E04_MUNCP_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E04_MUNCP_GEN",
                                DATATABLE_ID : "t_GEO09E04_MUNCP_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PUBLIC_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MUNCP_TX_SANS_D_PUBLIC_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_MUNCP_3",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé",
                        SELECTED_DATAVIEW_LAYER : "GEO09E04_MUNCP_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E04_MUNCP_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E04_MUNCP_GEN",
                                DATATABLE_ID : "t_GEO09E04_MUNCP_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PRIVE_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MUNCP_TX_SANS_D_PRIVE_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    }
                ]
            }, {
                ID : "RESIDENCE_MRC",
                TYPE : "ThemeSetGroup",
                TITLE : "Municipalités régionales de comté",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Res_MRC_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E05_MRC_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E05_MRC_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E05_MRC_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E05_MRC_GEN",
                                DATATABLE_ID : "t_GEO09E05_MRC_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PROV_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MRC_TX_SANS_D_PROV_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_MRC_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public",
                        SELECTED_DATAVIEW_LAYER : "GEO09E05_MRC_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E05_MRC_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E05_MRC_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E05_MRC_GEN",
                                DATATABLE_ID : "t_GEO09E05_MRC_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PUBLIC_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MRC_TX_SANS_D_PUBLIC_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_MRC_3",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé",
                        SELECTED_DATAVIEW_LAYER : "GEO09E05_MRC_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E05_MRC_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E05_MRC_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E05_MRC_GEN",
                                DATATABLE_ID : "t_GEO09E05_MRC_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PRIVE_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "MRC_TX_SANS_D_PRIVE_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    }
                ]
            }, {
                ID : "RESIDENCE_RA",
                TYPE : "ThemeSetGroup",
                TITLE : "Régions administratives",
                THEMESETS_ELEMENTS : [
                    {
                        ID : "Res_REG_ADM_1",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec",
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_GEO09E06_REG_ADM_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PROV_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour l'ensemble du Québec, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_SANS_D_PROV_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_REG_ADM_2",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public",
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_GEO09E06_REG_ADM_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PUBLIC_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau public, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_SANS_D_PUBLIC_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    },
                    {
                        ID : "Res_REG_ADM_3",
                        TYPE : "ThemeSet",
                        TITLE : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé",
                        SELECTED_DATAVIEW_LAYER : "GEO09E06_REG_ADM_GEN",
                        SELECTED_SEARCH_LAYER : "GEO09E06_REG_ADM_GEN",
                        THEMESET_MAP_SETTINGS : {
                            LAYERS_SETTINGS : [
                                {LAYER_ID : "GEO09E06_REG_ADM_GEN", ALPHA: 0.75, VISIBLE : true, LABEL_VISIBLE : true},
                                {LAYER_ID : "GEO09E01_CS_FRA_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E02_CS_ANG_STA_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E04_MUNCP_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E05_MRC_GEN", VISIBLE : false},
                                {LAYER_ID : "GEO09E17_ARRND", VISIBLE : false},
                            ]
                        },
                        THEMES: [
                            {
                                TYPE : "ThemeByRangesOfValues",
                                LAYER_ID : "GEO09E06_REG_ADM_GEN",
                                DATATABLE_ID : "t_GEO09E06_REG_ADM_GEN_residence",
                                DATACOLUMN_ID : "TX_SANS_D_PRIVE_T_{{VALUE}}",
                                REPRESENTATION_ENUM : "color",
                                AS_OVERLAY : false,
                                ENABLED : true,
                                LEGEND_TEXT : "Taux annuel de sorties sans diplôme ni qualification au secondaire pour le réseau privé, sexes réunis, {{TEXT}} (%)",
                                NUMBER_OF_RANGES : 6,
                                SCHEME : {
                                    ID : "RA_TX_SANS_D_PRIVE_T",
                                    SCHEME_ELEMENTS : [
                                        {
                                            MIN_VALUE : 0,
                                            MAX_VALUE : 10,
                                            REPRESENTATION : "rgba(251, 242, 196, 1)",
                                            LEGEND_TEXT : "moins de 10%"
                                        }, {
                                            MIN_VALUE : 10,
                                            MAX_VALUE : 12,
                                            REPRESENTATION : "rgba(229, 193, 133, 1)",
                                            LEGEND_TEXT : "10% à 12%"
                                        }, {
                                            MIN_VALUE : 12,
                                            MAX_VALUE : 16,
                                            REPRESENTATION : "rgba(224, 162, 120, 1)",
                                            LEGEND_TEXT : "12% à 16%"
                                        }, {
                                            MIN_VALUE : 16,
                                            MAX_VALUE : 18,
                                            REPRESENTATION : "rgba(219, 131, 107, 1)",
                                            LEGEND_TEXT : "16% à 18%"
                                        }, {
                                            MIN_VALUE : 18,
                                            MAX_VALUE : 100,
                                            REPRESENTATION : "rgba(199, 82, 42, 1)",
                                            LEGEND_TEXT : "18% et plus"
                                        }]
                                },
                            }
                        ],
                    }
                ]
            }
        ]
    };
});
